// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-radio-buttons_stretched {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/components/DialogRadioButtons/DialogRadioButtons.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR","sourcesContent":[".dialog-radio-buttons_stretched {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
